<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn @click.native="leave" color="error" icon flat exact>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline secondary--text">{{loading ? 'Loading' : taskData.name}}</v-toolbar-title>
  </v-toolbar>

  <v-layout @contextmenu.prevent="" row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-2" xs12 md10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else-if="courseEnded" row justify-center> 
        <v-flex class="py-5 my-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            Course Ended
          </div>
        </v-flex>
      </v-layout>
      <r-reading-task v-else-if="isReading"></r-reading-task>
      <r-lecture-task v-else-if="isLecture"></r-lecture-task>
      <r-practice-task v-else-if="isPractice"></r-practice-task>
      <r-nclex-task v-else-if="isNCLEX"></r-nclex-task>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import ReadingTask from './ReadingTask.vue'
import LectureTask from './LectureTask.vue'
import PracticeTask from './PracticeTask.vue'
import NclexTask from './NclexTask.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rReadingTask: ReadingTask,
    rLectureTask: LectureTask,
    rPracticeTask: PracticeTask,
    rNclexTask: NclexTask
  },
  data: () => ({
    loading: false,
    currentProgress: null,
    taskData: null,
    isReading: false,
    isLecture: false,
    isPractice: false,
    isNCLEX: false
  }),
  computed: {
    now () {
      return this.$store.getters.now
    },
    courseEnded () {
      if (this.now > this.progress.endTime) this.$router.push('/my-courses')
      return this.now > this.progress.endTime
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.currentProgress = this.$store.getters.currentProgress
      this.progress = this.$store.getters.progressByKey(this.currentProgress.progress)
      this.taskData = this.$store.getters.taskByKey(this.currentProgress.task)
      let linked = null
      if (this.taskData) {
        if (this.taskData.type === 'Reading') this.isReading = true
        else if (this.taskData.type === 'Lecture') this.isLecture = true
        else if (this.taskData.type === 'Practice') this.isPractice = true
        else if (this.taskData.type === 'NCLEX') this.isNCLEX = true
        else if (this.taskData.type === 'Linking') {
          linked = this.$store.getters.taskByKey(this.taskData.linkedTaskKey)
          if (linked.type === 'Reading') this.isReading = true
          else if (linked.type === 'Lecture') this.isLecture = true
          else if (linked.type === 'Practice') this.isPractice = true
          else if (linked.type === 'NCLEX') this.isNCLEX = true
        }
        if (this.$store.getters.questionsModuleLoaded) this.loading = false
        else {
          this.$store.dispatch('loadQuestions').then(() => {
            this.loading = false
          })
        }
      } else {
        this.$store.dispatch('setCurrentProgress', {progress: null, section: null, task: null})
        this.$router.push('/my-courses')
      }
    },
    leave () {
      this.$store.dispatch('setCurrentProgress', {
        progress: this.currentProgress.progress,
        section: this.currentProgress.section,
        task: null
      })
      this.$router.push('/my-courses/course-view/my-tasks')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myCourses/TaskView.vue